import React, { useContext, useRef, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { ConfigContext } from '../../contexts/config-context';
import { childTypes, typesFor, useListingForms } from '../../components/shared-components/listing-forms';
import { CategoryIcon, ListingTips, PropertyTypeIcon, PROPERTY_TYPES } from './listing-tips';
import '../../hs-theme.css';
import './new-listing.css';

const CategoryChoice = () => {
    const { t, i18n } = useTranslation(["new_listing"]);
    const { listingType } = useContext(ConfigContext);
    const navigate = useNavigate();
    const typeStep = useRef(null);
    const [picked, setPicked] = useState(null);
    // a group of types, such as business premises, picked before one of its types
    const [group, setGroup] = useState(null);
    const { forms, types } = useListingForms(i18n.language);

    const pickCategory = (category) => {
        setPicked(category);
        setGroup(null);
        setTimeout(() => typeStep.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 60);
    };

    const typeOptions = !picked ? []
        : group ? childTypes(forms, types, picked.code, group.id)
            : typesFor(forms, types, picked.code);
    const pickType = (type) => {
        if (childTypes(forms, types, picked.code, type.id).length > 0) setGroup(type);
        else navigate(`${picked.link}?vrsta=${type.id}`);
    };

    return (
        <main className='hs-nl-category'>
            <div className='hs-nl-intro'>
                <p className='hs-nl-eyebrow'>{t("form")}</p>
                <h1>{t("publish")}</h1>
                <p>{t("choose")}</p>
            </div>
            <div className='hs-nl-cats'>
                {listingType.map(category => {
                    const on = picked?.name === category.name;
                    return (
                        <button key={category.name} className={`hs-nl-cat ${on ? 'on' : ''}`} aria-pressed={on} onClick={() => pickCategory(category)}>
                            <span className='hs-nl-cat-icon'><CategoryIcon name={category.name} size={28} /></span>
                            <span className='hs-nl-cat-text'>
                                <span className='hs-nl-cat-name'>{t(category.name)}</span>
                                <span className='hs-nl-cat-desc'>{t(`${category.name}_desc`)}</span>
                            </span>
                            <span className='hs-nl-cat-go'>{t(on ? "picked" : "pick")}<span>{on ? '✓' : '→'}</span></span>
                        </button>
                    );
                })}
            </div>
            {picked &&
                <section ref={typeStep} className='hs-nl-type-step'>
                    <div className='hs-nl-type-head'>
                        <span className='hs-nl-step-num'>{group ? 3 : 2}</span>
                        <div>
                            <h2>{group ? t("subtype_question") : t(`type_question_${picked.name}`)}</h2>
                            <p>{group ? t("subtype_hint") : t("type_hint")}</p>
                        </div>
                    </div>
                    {group && <button className='hs-nl-back' onClick={() => setGroup(null)}>← {t("back_to_types")}</button>}
                    <div className='hs-nl-types'>
                        {typeOptions.map(type => (
                            <button key={type.id} className='hs-nl-type' onClick={() => pickType(type)}>
                                <span className='hs-nl-type-icon'><PropertyTypeIcon id={type.id} size={24} /></span>
                                <span className='hs-nl-type-text'>
                                    <span className='hs-nl-type-name'>{type.label}</span>
                                    {PROPERTY_TYPES[type.id] && <span className='hs-nl-type-desc'>{t(PROPERTY_TYPES[type.id].desc)}</span>}
                                </span>
                            </button>
                        ))}
                    </div>
                </section>}
            <div className='hs-nl-guide'>
                <div className='hs-nl-guide-head'>
                    <span className='hs-nl-guide-icon'>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 11v6M12 7.5h.01" /></svg>
                    </span>
                    <span className='hs-nl-guide-title'>{t("info")}</span>
                    <Link to='/vodic/oglasavanje'>{t("guide")} →</Link>
                </div>
                <ListingTips />
            </div>
        </main>
    );
};

export const NewListing = () => {
    const location = useLocation();

    return (
        <div className='hs hs-nl'>
            <Outlet />
            {location.pathname === '/postavi-oglas' && <CategoryChoice />}
        </div>
    );
};
